import { useCallback } from 'react';
import { useBrandingStore } from '../store/brandingStore';

/**
 * Хук для принудительного обновления CSS переменных брендинга
 * Используется для борьбы с кешированием старых цветов
 */
export const useForceBrandingUpdate = () => {
  const forceUpdateCSSVariables = useBrandingStore(state => state.forceUpdateCSSVariables);
  
  const forceUpdate = useCallback(() => {
    console.log('🔍 Forcing branding CSS variables update...');
    forceUpdateCSSVariables();
  }, [forceUpdateCSSVariables]);
  
  return forceUpdate;
};
